var GuestBookService = (function () {

    'use strict';

    //************ Variables ************//
    var form;
    var name;
    var city;
    var phone;
    var email;
    var message;
    var captcha;
    var device;

    //************ Functions ************//
    function clear() {
        name.val("");
        city.val("");
        phone.val("");
        email.val("");
        message.val("");
        device.val("");
        grecaptcha.reset(captcha);
    }

    function submit() {

        var isValidate = true;

        if (name.val() == '') {
            isValidate = false;
            name.addClass('has-error');
        }

        if (city.val() == '') {
            isValidate = false;
            city.addClass('has-error');
        }

        var strPhone = phone.val().split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

        if (strPhone.length < 11) {
            isValidate = false;
            phone.addClass('has-error');
        }

        if (email.val() == '') {
            isValidate = false;
            email.addClass('has-error');
        }

        if (message.val() == '') {
            isValidate = false;
            message.addClass('has-error');
        }

        if (grecaptcha.getResponse(captcha) == '') {
            form.find('.g-recaptcha').addClass('has-error');
            isValidate = false;
        }

        if (!isValidate) {
            return false;
        }

        AppService.toggleLoader();
        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            data: new FormData($(this)[0]),
            success: function (response) {
                if (response.code == '200') {
                    clear();
                    $('#modalGuestBook').modal('hide');
                    $('.js-modal-success-message').html(
                        'Спасибо. Ваша отзыв добавлен.<br>' +
                        'В скором времени<br>' +
                        'мы ответим на него.'
                    );
                    AppService.toggleLoader();
                    $('#modalSuccess').modal('show');
                }
            },
            error: AppService.toggleLoader
        });

        return false;
    }

    function init() {
        form = $('.js-guestbook-add-form');
        if(form.length) {
            name = form.find('#name');
            city = form.find('#city');
            phone = form.find('#phone');
            email = form.find('#email');
            message = form.find('#message');
            device = form.find('#device');
            device.attr('value',$('html').attr('class').replace(" smartbanner-show", "").replace(/ /g, "-"));
            captcha = CaptchaService.render(form.find('.g-recaptcha').get(0));
            form.on('submit', submit);
        }

        $('.js-guest-book-type-select').on('change', function () {

            if ($(this).val() == 'Negative') {
                $('.js-guest-book-type').removeClass('col-md-offset-3');
                $('.js-guest-book-complaint-type').show();
            } else {
                $('.js-guest-book-type').removeClass('col-md-offset-3').addClass('col-md-offset-3');
                $('.js-guest-book-complaint-type').hide();
            }
        });
    }

    //************ Public ************//
    return {
        init: init
    };
})();